/**
 * [description]
 * @param  {String|Number} price
 * @return {String}        converted currency (if converter available)
 */

export const getCurrency = (price) => (typeof ft !== 'undefined') ? ft.utl.getCurrencyString(price, true, true, true) : price.toString(); // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/utils/getCurrency/index.js